var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.modalAttr.isModalOpen)?_c('AppModal'):_vm._e()],1),_vm._v(" "),_c('HeroBanner'),_vm._v(" "),_c('UtilityNav',{attrs:{"content":_vm.utilityNav}}),_vm._v(" "),_vm._l((_vm.sections),function(section,index){return (
      section.id != 'baner1' &&
        section.id != 'baner2' &&
        section.id != 'baner3' &&
        section.id != 'baner44'
    )?_c('AppSection',{key:section.id,attrs:{"content":section,"section-index":index}}):_vm._e()})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6286a9bd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/vuejs/frontend/2023-launch/App.vue
// module id = Am1w
// module chunks = 4